// import "tvs-unified-lib/assets/index.css";
import React from "react";
import { useRoutes } from "react-router-dom";
import ErrorBoundary from "./providers/error-boundary";
import configAppRoutes from "./routers";
import { SnackbarWrapper } from "./snackbar";

function App() {
  const routes = useRoutes(configAppRoutes);

  return (
    <ErrorBoundary>
      <React.Fragment>
        <SnackbarWrapper>{routes}</SnackbarWrapper>
      </React.Fragment>
    </ErrorBoundary>
  );
}

export default App;
